import React from 'react';

import BreadcrumbItem from './BreadcrumbItem';
class Breadcrumbs extends React.Component {
    constructor(props) {
        super(props);

        this.props = props;
    }

    render() {
        const { option = [] } = this.props;
        const breadcrumbs = Object.entries(option).map((breadcrumb, index) => {
            const [_key, value] = breadcrumb;
            const { title, link, historyState } = value;

            if (!title) {
                return <span>error</span>;
            }

            return (
                <BreadcrumbItem
                    key={index}
                    index={index}
                    link={link}
                    historyState={historyState}
                    title={title}
                />
            );
        });

        return <div className="breadcrumb">{breadcrumbs}</div>;
    }
}

export default Breadcrumbs;
